import { useCompany } from './useCompany';

export const useOrganisationId = (): string => {
  const company = useCompany();
  return company.organisation.id;
};
